import React, { SVGAttributes } from 'react';

type HomeIconProps = SVGAttributes<unknown> & {
  isActive?: boolean;
};

export const HomeIcon = ({ isActive = false, ...props }: HomeIconProps): JSX.Element => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
    <g clipPath='url(#clip0_3891_131636)'>
      <path
        d='M22.1888 9.13828L12 1.45078L1.80192 9.13828C1.5911 9.33283 1.46433 9.60184 1.44849 9.88828V21.6277C1.44923 21.8706 1.54607 22.1034 1.71785 22.2752C1.88964 22.4469 2.12242 22.5438 2.36536 22.5445H8.47974V17.6255C8.47974 16.6931 8.85013 15.7988 9.50944 15.1395C10.1687 14.4802 11.063 14.1098 11.9954 14.1098C12.9278 14.1098 13.822 14.4802 14.4813 15.1395C15.1406 15.7988 15.511 16.6931 15.511 17.6255V22.5473H21.6244C21.8675 22.5466 22.1003 22.4498 22.2723 22.278C22.4442 22.1063 22.5412 21.8735 22.5422 21.6305V9.88828C22.526 9.60193 22.3993 9.33306 22.1888 9.13828Z'
        stroke='#485055'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={isActive ? '#485055' : 'none'}
      />
    </g>
    <defs>
      <clipPath id='clip0_3891_131636'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
